
    import './styles.scoped.css';
    export default {
  "drag-overlay": "awsui_drag-overlay_1ksmw_tqdhz_145",
  "drag-overlay-item": "awsui_drag-overlay-item_1ksmw_tqdhz_149",
  "drag-overlay-container": "awsui_drag-overlay-container_1ksmw_tqdhz_176",
  "active": "awsui_active_1ksmw_tqdhz_204",
  "placeholder": "awsui_placeholder_1ksmw_tqdhz_214",
  "placeholder-item": "awsui_placeholder-item_1ksmw_tqdhz_223",
  "placeholder-container": "awsui_placeholder-container_1ksmw_tqdhz_229",
  "sorting": "awsui_sorting_1ksmw_tqdhz_236"
};
  